module.exports = __webpack_public_path__ + "static/media/devis-auto.fc8960ea.webp";